import React from 'react';
import './Testimonials.css';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Sarah M.',
      role: 'Content Creator',
      rating: 5,
      text: 'The quality is incredible! My LinkedIn profile never looked better. Worth every penny.',
      avatar: '/assets/testimonials/avatar1.jpg'
    },
    {
      name: 'Michael K.',
      role: 'Entrepreneur',
      rating: 5,
      text: 'Generated professional headshots for my entire team. Saved thousands compared to a photo studio.',
      avatar: '/assets/testimonials/avatar2.jpg'
    },
    {
      name: 'Emma L.',
      role: 'Instagram Influencer',
      rating: 5,
      text: 'The artistic styles are amazing! My followers love the creative portraits. Game changer for content.',
      avatar: '/assets/testimonials/avatar3.jpg'
    },
    {
      name: 'David R.',
      role: 'Job Seeker',
      rating: 5,
      text: 'Updated my CV photo with the business style. Got more interview callbacks immediately!',
      avatar: '/assets/testimonials/avatar4.jpg'
    },
    {
      name: 'Lisa T.',
      role: 'Artist',
      rating: 5,
      text: 'Love the fantasy styles! Created unique profile pictures for all my social media accounts.',
      avatar: '/assets/testimonials/avatar5.jpg'
    },
    {
      name: 'James W.',
      role: 'Dating App User',
      rating: 5,
      text: 'My matches increased 3x after updating my photos. The styles really make you stand out!',
      avatar: '/assets/testimonials/avatar6.jpg'
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Loved by 50,000+ Users</h2>
          <p className="section-subtitle">
            See what our community is creating
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <img src={testimonial.avatar} alt={testimonial.name} className="testimonial-avatar" />
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-role">{testimonial.role}</p>
                </div>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </div>

        <div className="social-proof">
          <div className="proof-item">
            <h3>4.8</h3>
            <p>App Store Rating</p>
          </div>
          <div className="proof-item">
            <h3>50K+</h3>
            <p>Happy Users</p>
          </div>
          <div className="proof-item">
            <h3>1M+</h3>
            <p>Portraits Created</p>
          </div>
          <div className="proof-item">
            <h3>56+</h3>
            <p>Unique Styles</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;